import * as DIYReportActions from './action';
const initialState = {
    saveDIYConfig: [],
    saveDIYConfigFailure: [],
    downloadKeySuccess: [],
    downloadKeyFailure: []
}
const DIYReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case DIYReportActions.KIBANA_CONFIG_SAVE_SUCCESS:
            return state = {
                ...state,
                saveDIYConfig: action.data
            }
        case DIYReportActions.KIBANA_CONFIG_SAVE_FAILURE:
            return state = {
                ...state,
                saveDIYConfigFailure: action.data
            }
        case DIYReportActions.DOWNLOAD_KEY_EXTRACTION_SUCCESS:
            return state = {
                ...state,
                downloadKeySuccess: action.data
            }
        case DIYReportActions.DOWNLOAD_KEY_EXTRACTION_FAILURE:
            return state = {
                ...state,
                downloadKeyFailure: action.data
            }

        default: return state;
    }
};

export default DIYReportReducer; 